import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";

export default class StringEditor extends React.PureComponent {
    static propTypes = {
        schema: PropTypes.object.isRequired,
        theKey: PropTypes.any,
        isKeyEditable: PropTypes.bool,
        value: PropTypes.string,
        renderKey: PropTypes.func.isRequired,
        onChange: PropTypes.func.isRequired,
    };

    static defaultProps = {
        renderKey: () => null,
    };

    render() {
        const {theKey, value, renderKey} = this.props;

        return (
            <div className={styles.editor}>
                {renderKey(theKey)}
                <div className={styles.value}>
                    <input
                        value={value}
                        onChange={this.handleChange}
                        className="form-control form-control-smallish"
                    />
                </div>
            </div>
        );
    }

    handleChange = e => {
        const {theKey, onChange} = this.props;
        onChange(theKey, e.target.value);
    };
}
